export interface LocalStorageInterface {
  // Auth tokens
  getRefreshToken: () => string | null
  hasRefreshToken: () => boolean
  getIDToken: () => string | null
  storeTokens: (refreshToken: string | null, idToken: string | null) => void
  clearAuthTokens: () => void
}

export const localStorageItems = {
  refreshToken: "REFRESH",
  idToken: "TOKEN",
  needsToRefreshBookings: "NEEDS_TO_REFRESH_BOOKINGS",
}

export const sessionManager: LocalStorageInterface = {
  // TOKENS
  getRefreshToken: () => localStorage.getItem(localStorageItems.refreshToken),
  hasRefreshToken: () => !!localStorage.getItem(localStorageItems.refreshToken),
  getIDToken: () => localStorage.getItem(localStorageItems.idToken),
  storeTokens: (refreshToken: string | null, idToken: string | null) => {
    refreshToken &&
      localStorage.setItem(localStorageItems.refreshToken, refreshToken)
    idToken && localStorage.setItem(localStorageItems.idToken, idToken)
  },
  clearAuthTokens: () => {
    localStorage.removeItem(localStorageItems.refreshToken)
    localStorage.removeItem(localStorageItems.idToken)
  },
}
